module.exports = __webpack_public_path__ + "site/img/133.307daf60.jpg";